import { Skeleton } from "@/shared/components/ui/skeleton";
import useProductSupplierResponsesGridTemplate from "../utils/useProductSupplierResponsesGridTemplate";

export default function LoadingState() {
  const gridTemplate = useProductSupplierResponsesGridTemplate();

  return (
    <div className="w-full border-b border-border">
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={index} className="last:border-b-0 border-b border-border">
          <div
            className="grid items-center h-[56px] relative w-full"
            style={{
              gridTemplateColumns: gridTemplate,
            }}
          >
            {/* User Column */}
            <div className="flex items-center gap-2 h-full pr-4 pl-[40px] py-0 relative overflow-hidden">
              <Skeleton className="size-[32px] rounded-full shrink-0" />
              <div className="flex flex-col items-start shrink-0 min-w-0 gap-1">
                <Skeleton className="h-4 w-24 rounded" />
                <Skeleton className="h-3 w-32 rounded" />
              </div>
            </div>

            {/* Progress Column */}
            <div className="flex flex-col gap-1 items-center justify-center h-full py-0 relative">
              <div className="flex items-start gap-1 shrink-0 w-full">
                <Skeleton className="h-4 w-12 rounded" />
                <Skeleton className="h-4 w-1 rounded" />
                <Skeleton className="h-4 w-10 rounded" />
              </div>
              <Skeleton className="h-2 w-full rounded-full" />
            </div>

            {/* Count Column */}
            <div className="flex items-center justify-center h-full px-2 py-0 relative">
              <Skeleton className="h-4 w-8 rounded" />
            </div>

            {/* Time 1 Column */}
            <div className="flex items-center justify-center h-full px-2 py-0 relative">
              <Skeleton className="h-4 w-12 rounded" />
            </div>

            {/* Time 2 Column */}
            <div className="flex items-center justify-center h-full px-2 py-0 relative">
              <Skeleton className="h-4 w-10 rounded" />
            </div>

            {/* Status Column */}
            <div className="flex items-center justify-center h-full px-4 py-0 relative">
              <Skeleton className="h-5 w-20 rounded-full" />
            </div>

            {/* Actions Column */}
            <div className="flex items-center justify-end h-[56px] py-0 relative">
              <div className="flex items-center justify-center px-[8px] h-full relative shrink-0 w-[41px]">
                <Skeleton className="h-8 w-8 rounded" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
